<section class="dashboards">
  <ts-page-header>
    <ng-container page-header-title>
      <ts-breadcrumb [items]="[{ label: 'Dashboards', routerLink: ['/dashboard'] }]"></ts-breadcrumb>
    </ng-container>
    <ng-container page-header-action-buttons>
      <ts-button
        [appAuthorize]="
          (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_CREATE : Permission.DASHBOARDS_CREATE_EDIT
        "
        denyAction="disable"
        variant="primary"
        icon="add"
        (click)="openCreateDashboardDialog()"
        >New Dashboard
      </ts-button>
    </ng-container>
  </ts-page-header>

  <section class="dashboards__list">
    <ng-container *ngIf="dataSource; else LoadingBar">
      <ng-container *ngIf="dataSource.data.length; else noDashboards">
        <div class="old-ts-table-container">
          <table
            mat-table
            matSort
            [matSortActive]="'name'"
            [matSortDisableClear]="true"
            [matSortDirection]="'asc'"
            [dataSource]="dataSource"
            [trackBy]="trackByFn"
          >
            <!-- Name -->
            <ng-container matColumnDef="name">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let dashboard" (click)="rowClicked(dashboard)">
                <div class="ts-cell-multlines">
                  <span class="font-medium">{{ dashboard?.name?.trim()?.length ? dashboard?.name : 'Untitled' }}</span>
                  <span class="text-black-400">{{ dashboard?.description }}</span>
                </div>
              </td>
            </ng-container>

            <!-- Created At -->
            <ng-container matColumnDef="created_by">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Created by</th>
              <td mat-cell *matCellDef="let dashboard" (click)="rowClicked(dashboard)">
                <div class="ts-cell-with-avatar">
                  <img src="{{ dashboard?.user?.avatar_url }}" alt="" />
                  {{ dashboard?.user?.name }}
                </div>
              </td>
            </ng-container>

            <!-- Created At -->
            <ng-container matColumnDef="created_at">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Created at</th>
              <td mat-cell *matCellDef="let dashboard" (click)="rowClicked(dashboard)">
                {{ dashboard?.created_at | date: 'MMM dd, y' }}
              </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let dashboard">
                <ts-button
                  [debounceTime]="0"
                  type="icon"
                  icon="more_horiz"
                  color="accent"
                  [matMenuTriggerFor]="menu"
                  [appAuthorize]="canShowThreeDotMenu()"
                  denyAction="disable"
                ></ts-button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    [appAuthorize]="isAllowedToEdit(dashboard)"
                    [routerLink]="['./' + dashboard?.id]"
                    [queryParams]="{ editmode: 'true' }"
                  >
                    <ts-icon [icon]="'edit'"></ts-icon>
                    Edit
                  </button>
                  <button
                    mat-menu-item
                    (click)="duplicate(dashboard)"
                    [appAuthorize]="
                      (newPermissionsEnabled$ | async)
                        ? NewPermission.DASHBOARDS_CREATE
                        : Permission.DASHBOARDS_CREATE_EDIT
                    "
                  >
                    <ts-icon icon="ts_copy" iconColor="black"></ts-icon>
                    Duplicate
                  </button>
                  <button
                    class="red-delete"
                    mat-menu-item
                    [appAuthorize]="
                      (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_DELETE : Permission.DASHBOARDS_DELETE
                    "
                    (click)="deleteDashboard(dashboard)"
                  >
                    <ts-icon icon="ts_trash-alt" color="red"></ts-icon>
                    Delete
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <tr class="borders" mat-header-row *matHeaderRowDef="dashboardsTableColumns; sticky: true"></tr>
            <tr class="dashboard-row" mat-row *matRowDef="let dashboard; columns: dashboardsTableColumns"></tr>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </section>
</section>

<ng-template #LoadingBar>
  <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
</ng-template>

<ng-template #noDashboards>
  <section class="no-dashboards w-full h-full flex flex-col justify-center items-center">
    <img class="no-dashboards__image" src="assets/images/empty_list.svg" alt="No Dashboards Found" />
    <h5 class="mt-0 text-center">Looks like you haven't created any dashboards yet.</h5>
    <h5 class="m-0 text-center">Click on the 'New Dashboard' button above to create one.</h5>
  </section>
</ng-template>
